import { render } from "./ClientsInOffice.vue?vue&type=template&id=008d8b32&scoped=true"
import script from "./ClientsInOffice.vue?vue&type=script&lang=js"
export * from "./ClientsInOffice.vue?vue&type=script&lang=js"

import "./ClientsInOffice.vue?vue&type=style&index=0&id=008d8b32&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008d8b32"]])

export default __exports__